import { Component, Input, ElementRef, Renderer2, HostListener } from '@angular/core';
import { PmdAccordionItem } from './accordion-group.component';
import { PmdAccordionConfig } from './accordion.config';

/**
 * List of classes to add to Propeller Accordion instances based on host attributes to
 * style as different variants.
 */
const ACCORDION_HOST_ATTRIBUTES = [
  'pmd-accordion',
  'pmd-accordion-nospace',
  'pmd-accordion-outlined',
];

/**
 * Directive for a Propeller Accordion.
 */
@Component({
  selector: 'pmd-accordion, [pmd-accordion-outlined], [pmd-accordion-nospace]',
  exportAs: 'pmdAccordion',
  template: `<ng-content></ng-content>`,
  host: {
    '[attr.aria-multiselectable]': 'closeOthers',
    class: 'accordion pmd-accordion',
    style: 'display: block',
  },
  standalone: false,
})
export class PmdAccordion {
  /** if `true` expanding one item will close all others */
  /** Default value is 'true' */
  @Input() closeOthers: boolean;

  public groups: PmdAccordionItem[] = [];
  constructor(
    config: PmdAccordionConfig,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    Object.assign(this, config);
  }

  closeOtherPanels(openGroup: PmdAccordionItem): void {
    if (!this.closeOthers) {
      return;
    }
    this.groups.forEach((group: PmdAccordionItem) => {
      if (group !== openGroup) {
        group.isOpen = false;
      }
    });
  }

  addGroup(group: PmdAccordionItem): void {
    this.groups.push(group);
  }

  removeGroup(group: PmdAccordionItem): void {
    const index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  }

  ngOnInit() {
    for (const attr of ACCORDION_HOST_ATTRIBUTES) {
      if (this._hasHostAttributes(attr)) {
        (this.elementRef.nativeElement as HTMLElement).classList.add(attr);
      }
    }
  }

  _hasHostAttributes(...attributes: string[]) {
    return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
  }

  _getHostElement() {
    return this.elementRef.nativeElement;
  }

  currentIndex = 0;

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): any {
    for (let i = 0; i < this.groups.length; i++) {
      if (
        this.groups[i].elementRef.nativeElement ==
        document.activeElement.parentElement.parentElement.parentElement
      ) {
        this.currentIndex = i;
      }
    }
    if (e.keyCode === 40 || e.key === 'ArrowDown') {
      if (this.groups[this.currentIndex + 1]) {
        const el: any = this.groups[this.currentIndex + 1].elementRef.nativeElement;
        console.log(el);
        el.children[0].children[0].children[0].focus();
        this.currentIndex++;
      } else {
        const el: any = this.groups[0].elementRef.nativeElement;
        console.log(el);
        el.children[0].children[0].children[0].focus();
        this.currentIndex = 0;
      }
    }
    if (e.keyCode === 38 || e.key === 'ArrowUp') {
      if (this.groups[this.currentIndex - 1]) {
        const el: any = this.groups[this.currentIndex - 1].elementRef.nativeElement;
        console.log(el);
        el.children[0].children[0].children[0].focus();
        this.currentIndex++;
      } else {
        const el: any = this.groups[this.groups.length - 1].elementRef.nativeElement;
        console.log(el);
        el.children[0].children[0].children[0].focus();
        this.currentIndex = 0;
      }
    }
  }
}
